export enum TabToTabChannelName {
    ActiveBusinessTransaction = 'activeBusinessTransaction',
    QuestionnaireReceived = 'questionnaireReceived',
    QuestionnaireRequested = 'questionnaireRequested',
    Gemview = 'gemview'
}
